module.exports = __webpack_public_path__ + "static/generate-step-3-4d0a12416f09956fcda712284c4d58bf.svg";